import {Component} from '@angular/core';

@Component({
  selector: 'app-pre',
  templateUrl: './pre.component.html',
  styleUrls: ['./pre.component.css']
})
export class PreComponent {

}



// WEBPACK FOOTER //
// ./src/app/auth/register/pre/pre.component.ts